module.exports = __webpack_public_path__ + "img/netbanking.4b581305.svg";